/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import Header from '@/components/header/header'
import styles from './privacy-agreement.module.scss'
import classNames from 'classnames'
import { getParams } from '@bihu/common-js'
import getHostNameObj from '@/hooks/get-host-name-obj'

interface Props{}
// 隐私协议
const PrivacyAgreement:React.FC<Props> = () => {
  const hostNameObj = getHostNameObj()

  const [isShowHeader, setIsShowHeader] = useState(false)
  const [name] = useState(hostNameObj.appName)

  useEffect(() => {
    if (getParams(undefined, 'isShowHeader')) {
      setIsShowHeader(true)
    }
  }, [])

  const { companyName } = hostNameObj

  // 卫付通隐私协议
  const youqianlaiPrivacy = () => {
    return (
      <>
        <p className={styles.bold}>重要提示：</p>
        <p className={styles.bold}>卫付通平台由深圳市鹏恒融资担保有限公司、 厦门乐真网络科技有限公司所有并联合运营（以下简称“我们”或“卫付通”），为广大小微企业主、个体工商户、普通工薪阶层等普惠金融需求人群提供专业、优质、负责任的融资咨询、融资担保及衍生性服务的APP。本APP仅为信息中介平台，不参与担保审批、贷款发放或资金流转环节。我们依照本隐私协议处理您的个人信息与隐私。卫付通平台非常重视保护您的隐私和个人信息。我们将通过本摘要向您简单、直观的说明《卫付通隐私政策》的主要内容。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>我们收集您的个人信息种类</p>
        <div className={styles.emptyLine}></div>
        <p>一．本APP通过收集用户基本信息及融资资质信息，为用户提供以下两类核心服务：</p>
        <p>（1）确定您的资信状况以提供担保服务为了帮助深圳市鹏恒融资担保有限公司（以下简称“担保机构“）确认您的资信状况以便决定您的担保额度或担保资质以及用于可能的争议解决，担保机构将收集并使用如下信息： 您的姓名、有效证件信息、手机号、婚姻情况、学历、居住城市、居住地址、行业、职业、公司名称、公司性质、职位、行驶证信息(包括影像)、交通违章信息、法院失信执行信息、不动产信息(包括影像)、动产信息、经营情况信息、保险信息、证券信息、纳税信息、收入信息、公积金及社保信息。</p>
        <p>（2）提供融资咨询推荐服务过程中，进行预审和身份验证
        您在使用平台提供的融资咨询推荐服务时，为了向您匹配适合您的融资咨询服务机构，我们将收集如下您的个人信息以使匹配您需求的融资咨询服务机构能够通过短信或电话方式联系并邀请您前往其线下营业机构为您提供融资咨询推荐服务，由融资咨询服务机构线下邀约评估并由其向您推荐合适的贷款产品，为此我们需要收集您的如下个人信息，用于融资咨询推荐服务的预审和身份验证：
        您的姓名、有效证件信息、手机号、婚姻情况、学历、居住城市、居住地址、行业、职业、公司名称、公司性质、职位、当前单位工龄、工资发放形式、月收入、年收入、邮箱、联系人信息、还款来源、社保缴纳、公积金缴纳、房产信息、车辆信息、保险保单信息、芝麻分、信用卡信息、银行卡信息。
        如您不同意融资咨询服务机构对您进行短信营销的，您可以通过短信内容提供的方式进行拒绝；如您不同意融资咨询服务机构对您进行电话营销的，您可以通过电话方式明确向表示拒绝。请您理解，为保障服务质量，您的通话可能会被全程进行录音。
        您应知悉，如您选择不提供或不同意采集、使用以上个人信息，我们将无法提供相应服务。（以上两类服务合称<span className={styles.bold}>“卫付通服务”</span>）。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>我们如何收集和使用您的个人信息</p>
        <div className={styles.emptyLine}></div>
        <p>除法律法规另有规定外，在收集和使用您的个人信息前，我们会征得您授权同意。我们收集和使用您的个人信息的种类场景如下，相应收集使用的个人信息详见正文第一部分：</p>
        <p>一.为您提供担保服务或融资咨询推荐服务；</p>
        <p>二.我们与第三方开展其他业务合作，根据具体业务场景需要及法律法规的要求，在必要时我们将单独获得您的授权。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>系统权限说明</p>
        <div className={styles.emptyLine}></div>
        <p>我们在提供产品和服务过程中，可能需要申请以下系统权限：<span className={styles.bold}>网络通讯、通知权限、相册与存储权限、位置权限、摄像头、电话、麦克风、设备信息。</span>若您不希望我们继续获取某项权限，您可以通过所使用的设备随时选择关闭已开启的权限或对权限进行管理。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>您如何联系我们</p>
        <div className={styles.emptyLine}></div>
        <p>如您对本隐私政策存在任何疑问、投诉、反馈和建议，您可以通过卫付通联系电话：4006060609联系我们。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>概述：</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>一．卫付通平台（由深圳市鹏恒融资担保有限公司、厦门乐真网络科技有限公司联合运营）深知个人信息对用户(以下简称“您”)的重要性，并会尽全力保护您对自身的个人信息的安全可控。卫付通平台恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少必要原则、确保安全原则、主体参与原则、公开透明原则等，并将采取相应的安全保护措施来保护您的个人信息。</p>
        <p className={styles.bold}>二．请您在使用卫付通的产品或服务前，建议您仔细阅读并了解《卫付通隐私政策》正文所有条款。一旦您使用或继续使用我们的产品/服务，即表示您同意我们按照本政策（包括后续修订内容）处理您的个人信息。</p>
        <p className={styles.bold}>三．在您使用我们的产品/服务时，除本政策外，我们可能还会在相应的业务场景与您签署《卫付通注册协议》、《个人信息处理授权书》等其他协议或相关服务条款约定处理您的个人信息的相关事项，与本政策共同组成您的个人信息相关授权内容。</p>
        <p className={styles.bold}>四．本政策适用范围</p>
        <p className={styles.bold}>（一）本政策适用于卫付通的网络平台向您提供各项产品/服务，包括“卫付通”应用程序（App）、微信平台账号、小程序及其他各类由我们运营和管理的网站、客户端和页面（本政策适用范围统称为“卫付通平台”或“我们”），以及我们通过合作方平台提供的所有产品/服务。适用的时间为您初次登录并注册卫付通平台账号起，至您完成注销卫付通平台账号，或者卫付通根据自身风控及业务需求终止为您提供服务之日止。</p>
        <p className={styles.bold}>（二）当您在使用卫付通平台接受第三方提供的服务时，第三方可能会通过卫付通平台收集您的姓名、电话号码及其他第三方服务所必需的信息。在经过您的明示同意后，第三方可收集您的相关个人信息。如您拒绝，将可能会导致您无法在我们的网络平台上使用第三方的相应服务，但这不影响您使用卫付通平台的其他产品/服务。</p>
        <p className={styles.bold}>对于您在使用第三方产品/服务时主动提供给第三方的相关信息，卫付通平台将视为您允许该第三方收集这些信息。对于第三方在向您提供服务时处理您的个人信息的行为，您可关注第三方的个人信息处理规则。如您对该第三方的产品/服务或其处理您个人信息的行为有异议，或其违反相关法律法规或与您之间的其他约定，您可向我们反馈或与该第三方协商解决或对其采取合法的法律措施；我们将尽商业上合理的努力推动第三方解决问题。</p>
        <p className={styles.bold}>（三）特别地，您同意我们为了向您提供卫付通服务的需要，将您的个人信息（包括姓名、手机号码、身份证号码以及贷款申请信息）共享给融资咨询服务机构等第三方机构，以便于融资咨询服务机构等第三方机构为您提供融资咨询推荐服务，具体个人信息处理规则由融资咨询服务机构等第三方机构与您另行约定。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>正文：</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>本政策将帮助您了解以下内容：</p>
        <p>1、我们如何收集和使用您的个人信息</p>
        <p>2、信息保护和储存</p>
        <p>3、您的权利</p>
        <p>4、信息的共享、转让与委托处理</p>
        <p>5、信息披露与保密</p>
        <p>6、账号注销渠道及时效</p>
        <p>7、未成年人隐私权特别约定</p>
        <p>8、修订</p>
        <p>9、效力和适用</p>
        <p>10、联系我们</p>
        <p>11、法律管辖</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>1、我们如何收集和使用您的个人信息</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>1.1 您同意并授权卫付通平台及关联技术公司处理您的下列信息：</p>
        <p>1.1.1 详细处理的信息：<span className={styles.bold}>以附件一列明为准</span></p>
        {/* <p>1.1.2卫付通会对卫付通的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示卫付通的产品或服务的整体使用趋势，但这些统计信息不会包含您的任何身份识别信息，且该等信息将无法被复原。</p> */}
        <p>1.1.2根据法律法规或经您同意或授权的其他用途。</p>
        {/* <p>1.1.3邀请您参与有关卫付通服务的调查，我们会记录、保存和分析您的填写的内容信息，未经过您的授权，我们不会对外提供您的填写具体内容。</p> */}
        {/* <p>1.1.4根据法律法规或经您同意或授权的其他用途。</p> */}
        <p className={styles.bold}>1.2 您同意并授权卫付通及其关联技术公司通过以下途径获取您的信息：</p>
        <p className={styles.bold}>1.2.1 卫付通为您提供相应服务页面，您可在页面自行输入您的相应信息（包含身份信息、教育信息、手机通讯录、联系人信息、车辆信息、驾照信息、工作信息、公积金缴存信息、资产信息等），具体填写内容，以展示界面为准。</p>
        <p className={styles.bold}>1.2.2 卫付通通过1.2.1所述的方式获取您的信息时，不会保存您的账户和密码信息，该等信息和数据的获取是一次性的，除非得到您的再次授权，否则卫付通不会以您的名义发起登录而采集您的信息。</p>
        {/* <p className={styles.bold}>1.2.3 通过我们APP嵌入的第三方SDK，收集、传输您的个人信息：</p>
        <p className={styles.bold}>当您使用第三方提供的服务时，我们会在获得您的同意或确保第三方获得你的授权同意后，以及其他符合法律法规规定的情形下共享对应信息。您可以通过本清单中列举的相关信息了解第三方会如何处理您的个人信息。我们也会对第三方获取个人信息的行为进行严格约束，以保护您的个人信息安全。</p>
        <p className={styles.bold}>为保障卫付通平台稳定运行或实现相关功能，我们还可能会接入由第三方提供的软件开发包（SDK）实现前述目的。我们对接入的相关第三方SDK同时在以下清单中列明。您可以通过目录中提供的链接查看第三方的数据使用和保护规则。请注意，第三方SDK可能由于版本升级、策略调整等原因导致其个人信息处理类型发生变化，请以其公示的官方说明为准。</p> */}
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>用户面部数据相关隐私政策:</p>
        <div className={styles.emptyLine}></div>
        <p>1.1 我们收集哪些面部数据说明：我们的应用收集您通过摄像头提供的面部图像数据，这可能包括面部特征、表情和其他与面部有关的生物特征信息。这些数据仅用于进行个人身份识别，以便为用户提供服务。</p>
        <p>1.2 我们如何使用面部数据说明：收集到的面部数据主要用于以下目的：（1）身份识别：使用面部数据进行身份识别。（2）信息认证：只有在身份认证的条件下才能使用应用的主要业务，通过三方合规机构核实用户身份信息。我们承诺不会将收集的面部数据用于未经用户明确同意的任何其他目的。</p>
        <p>1.3 数据是否会与任何第三方共享说明：我们的应用收集您通过摄像头提供的面部图像数据仅用于三方进行身份识别，不用于其他任何用途。（活体识别由上海璟梦信息科技有限公司提供，并保证不存储用户面部数据。）</p>
        <p>1.4 我们将面部数据存储位置的说明：只会暂时保存在服务器中并采取加密保护措施，认证结束后将立即进行删除</p>
        <p>1.5 用户需要确保向我们提供/输入的原始数据和资料(如有)来源合法合规，不侵犯任何第三方的合法权益，对于需要获得第三方明示同意或授权的已经取得相应证明。</p>
        <p className={styles.bold}>1.2.4 其他机构基于您的授权，在您所授权的时效及范围内，根据卫付通的请求或该机构主动向卫付通提供您的信息。</p>
        <p className={styles.bold}>1.2.5 设备权限调用说明</p>
        <p className={styles.bold}>如果您是首次使用该功能的，我们会以弹窗形式征得您的同意或授权，如您不同意调用该权限的，则无法使用该功能，但不会影响您使用其他功能或服务。您也可以通过您的设备设置，关闭相关授权。</p>
        <table border={1} cellSpacing={0} cellPadding={4}>
          <tbody>
            <tr>
              <td className={styles.bold}>设备权限</td>
              <td className={styles.bold}>业务功能</td>
              <td className={styles.bold}>目的</td>
              <td className={styles.bold}>是否可关闭</td>
            </tr>
            <tr>
              <td>网络通讯</td>
              <td>为各项服务/产品提供网络通讯</td>
              <td>为流畅使用APP及各项服务/产品提供网络通讯</td>
              <td>是</td>
            </tr>
            <tr>
              <td>通知权限</td>
              <td>消息推送提醒功能</td>
              <td>为了向您提供或推荐融资咨询推荐服务和/或产品及APP最新相关信息</td>
              <td>是</td>
            </tr>
            <tr>
              <td>位置权限</td>
              <td>基于部分产品对用户所在区域有一定的要求，您不提供将影响该部分产品的申请，但不影响其他产品。</td>
              <td>为了基于您所在地点为您提供推荐服务</td>
              <td>是</td>
            </tr>
            <tr>
              <td>摄像头/相机</td>
              <td>实名认证、人脸识别</td>
              <td>在身份验证的场景下，需要调用您的摄像头进行身份证、人脸信息的拍摄</td>
              <td>是</td>
            </tr>
            <tr>
              <td>电话权限</td>
              <td>点击客户/投诉电话</td>
              <td>为了方便您在给客服人员打电话时预填客服联</td>
              <td>是</td>
            </tr>
            <tr>
              <td>麦克风</td>
              <td>当您与我们或融资资信服务机构的客服进行语言沟通，申请产品时声音录制、发送语言文件时，我们需要申请此权限。</td>
              <td>在人脸识别、与客服进行语言沟通或视频认证的场景下收集您的语音内容</td>
              <td>是</td>
            </tr>
            <tr>
              <td>相册与储存权限</td>
              <td>上传图片或其他资料、存储缓存数据、记录上网行为的日志信息</td>
              <td>方便您保存并上传视频或文件或图片（包括您拍摄的身份证图片、人脸图片）</td>
              <td>是</td>
            </tr>
            <tr>
              <td>设备信息（设备ID、IMSI(国际移动用户识别码)、MAC地址、IP地址）</td>
              <td>用于识别常用设备、信用审核评估、保护账户安全</td>
              <td>获取标记权限向您提供更优质、安全的服务及内容</td>
              <td>是</td>
            </tr>
            <tr>
              <td>读取电话状态权限</td>
              <td>安全风控和服务推荐，需要获取您的本机识别码（IMEI、IMSI）</td>
              <td>为了完成安全风控和服务推荐</td>
              <td>是</td>
            </tr>
          </tbody>
        </table>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>1.3征得授权同意的例外</p>
        <div className={styles.emptyLine}></div>
        <p>根据相关法律法规、监管规定、行业标准，符合以下情形之一的，我们可能会收集、使用您的个人信息而无需事先征得您授权同意：</p>
        <p>1.3.1为履行我们的法定职责或者法定义务所必需，包括：</p>
        <p>（1）履行国家法律法规及行业主管部门有关规定的义务。</p>
        <p>（2）履行与国家安全、国防安全直接相关的义务。</p>
        <p>（3）履行与公共安全、公共卫生、重大公共利益直接相关的义务。</p>
        <p>（4）履行与刑事侦查、起诉、审判和判决执行等直接相关的义务。</p>
        <p>（5）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到您同意的。</p>
        <p>1.3.2为订立、履行您作为一方当事人的合同所必需。</p>
        <p>1.3.3为维护我们所提供的服务的安全稳定运行所必需，包括发现、处置产品或服务的故障，及识别、处置金融产品或服务中的欺诈或被盗用等情形。</p>
        <p>1.3.4依照本法规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息，包括从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道。</p>
        <p>1.3.5法律、行政法规规定的其他情形。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>2、信息保护和存储</p>
        <div className={styles.emptyLine}></div>
        <p>2.1 为保障您的信息安全，卫付通采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失。卫付通对可能接触到您的信息的员工或外包人员也采取了严格管理，包括根据岗位的不同采取不同的权限控制，与他们签署保密声明，监控他们的操作情况等措施。</p>
        <p>2.2您的信息存储于中国境内的服务器上，为了安全及备份的需要，卫付通可能将您的信息和资料储存到卫付通合作的具备相应安全措施的公司（如：阿里云计算有限公司的"阿里云"）的服务器上。</p>
        <p>2.3我们需要在与您之间的整个业务存续期间保存您的个人信息，以向您提供相应的服务、保障您的账号安全和平台系统安全，在与您的业务结束之后，除非您主动向我们申请注销平台信息，否则我们将保存您的个人信息不少于五年。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>3、您的权利</p>
        <div className={styles.emptyLine}></div>
        <p>我们深知您对个人信息权益的重视，我们将参照中国相关的法律、法规、监管规定、行业标准，保障您在我们的个人信息处理活动中的权利。</p>
        <p>您有权按以下方式行使相关权利：</p>
        <p>3.1知情权</p>
        <p>您有权了解我们对您的个人信息的处理情况。我们通过本政策向您说明了我们如何以收集、使用、保存、提供等方式处理您的个人信息，以及我们为您提供的查询、更新、删除和保护这些个人信息的方式。</p>
        <p>您可通过App内【我的-设置-协议】路径查看本政策，了解我们对您的个人信息的处理情况。</p>
        <p>3.2决定权</p>
        <p>您有权限制或拒绝我们对您的个人信息进行处理。您在下载并打开我们的App并阅读本政策后，有权拒绝同意本政策，我们将无法处理您的个人信息。如您同意使用我们的产品或服务，我们将按制定的个人信息处理规则进行个人信息处理行为。您也有权直接申请注销您的账户。如果您需要注销账号，您可以从【我的-设置-注销】路径进行注销。</p>
        <p>3.3查阅、复制权</p>
        <p>您可通过App内【我的-设置-协议】路径查看本政策</p>
        <p>您可以通过【我的-常用功能】查看订单信息、申请记录等信息。</p>
        <p>3.4更正、补充权</p>
        <p>若您发现我们处理的您的个人信息不准确或者不完整的，您可进行更正、补充，我们有权对您要求更正、补充的个人信息进行核实。您可通过App内【我的-设置-基本信息】路径更正、补充您的个人信息。若通过该路径仍然无法满足您的需求，您可通过联系客服电话进行处理。</p>
        <p>3.5解释权</p>
        <p>您可以要求我们对个人信息处理规则的内容进行解释说明。我们通过本政策向您说明了我们对您的个人信息的处理规则，包括如何以收集、使用、保存、提供等方式处理您的个人信息，以及我们为您提供的查询、更新、删除和保护这些个人信息的方式。</p>
        <p>如果通过上述途径仍然无法解决您的问题，您可通过联系客服电话进行处理。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>4、信息的共享、转让与委托处理</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>4.1 信息的共享</p>
        <p><span className={styles.bold}>您同意并授权卫付通在下列情况下将您的信息与第三方共享，</span>在信息共享过程中，卫付通将严格采取国家现行法律法规要求的数据传输信息方法，也采用合同约定方式严格要求信息接收方在法律法规的规定下保护您的信息，请您了解，共享个人信息仅在下列场景中发生，如果信息接收方给您造成了任何损失，您可向我们反馈或与该第三方协商解决或对其采取合法的法律措施，我们将尽商业上合理的努力推动第三方解决问题：</p>
        <p>4.1.1 为了向您提供或推荐卫付通关联公司和合作公司的融资咨询推荐服务和/或产品，更好地向您匹配符合您需求的融资咨询服务机构，将个人信息（包含本政策1.1.2及1.1.3条所列信息）共享给卫付通关联公司和合作公司，且您同意卫付通关联公司和合作公司通过电话、电子邮件、站内信、手机短信和传真等方式向您发送服务状态的通知、营销活动及其他商业性电子信息。</p>
        <p>4.1.3 在您违反有关法律法规、本声明、您与卫付通签署相关声明时，向卫付通及卫付通关联公司的合作伙伴类第三方提供，包括诉讼、仲裁；</p>
        <p>4.1.4 只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议；</p>
        <p>4.1.5 为维护卫付通和/或其他卫付通用户的合法权益；</p>
        <p>4.1.6 为遵守适用的法律法规、法院裁定或其他法律程序的规定、相关政府机关的要求；</p>
        <p>4.1.7 若前述个人信息涉及个人敏感信息的，卫付通将在共享相关信息前取得您的独立授权。</p>
        <p className={styles.bold}>4.1.8 特别地，您同意我们为了向您提供融资咨询推荐服务的需要，将您的个人信息（包括姓名、手机号码、身份证号码以及贷款申请信息）共享给第三方融资咨询服务机构，以便于第三方融资咨询服务机构为您提供与融资咨询推荐服务相关的预审和身份验证，向您邀约线下评估并由其通过线下方式向您推荐合适的贷款产品，具体个人信息处理规则由第三方融资咨询服务机构与您另行约定。</p>
        <p className={styles.bold}>4.2 信息的转让</p>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p>4.2.1事先获得您的明确同意；</p>
        <p>4.2.2根据法律法规或强制性的行政或司法要求；</p>
        <p>4.2.3在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息的处理目的、处理方式时，我们将要求该公司、组织重新取得您的明确同意。</p>
        <p className={styles.bold}>4.3 委托处理</p>
        <p>为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我们可能会委托有能力的我们的关联公司或其他专业机构代表我们来处理信息。我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。在委托关系解除或终止后，受托公司不再保存个人信息。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>5、信息的披露与保密</p>
        <div className={styles.emptyLine}></div>
        <p>5.1卫付通将根据法律法规规定对您的个人信息予以保密不会对外披露您的个人信息，但下列情形除外：</p>
        <p>5.1.1 法律、法规、规章及其他规范性文件另有规定；</p>
        <p>5.1.2 政府机关、司法机关及监管部门提出要求；</p>
        <p>5.1.3 相关信息已成为公开信息；</p>
        <p>5.1.4 本政策另有约定；</p>
        <p>5.1.5获得您的同意需要对外披露的情况。</p>
        <p>5.2您应当了解，互联网环境并非百分之百安全，我们将尽力确保您的个人信息安全，如果因为我们的原因导致您的信息被损坏或泄露，导致您的合法权益受损，我们将承担相应的法律责任。如果发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
        <p className={styles.bold}>5.3请您务必妥善保管好您的用户名、密码及其他身份要素。您在使用卫付通平台提供的服务时，我们会通过您的用户名、密码及其他身份要素来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。如您发现前述信息可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>6、账号注销渠道及时效</p>
        <div className={styles.emptyLine}></div>
        <p>6.1 在卫付通app我的页面"设置"选项中可完成注销流程。</p>
        <p>6.2 注销处理流程时间为1-14个工作日。</p>
        <p className={styles.bold}>6.3 您申请注销卫付通平台账号后，我们将停止为您提供服务、停止使用、对外提供您的个人信息，并按照法律法规或监管部门规定执行后续信息的处理流程。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>7、未成年人隐私权特别约定</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>卫付通平台重视未成年人的个人信息保护，卫付通不向未成年人提供服务。我们不会主动收集、处理未满18周岁未成年人的信息。如您为未成年人，建议请您终止并注销使用卫付通服务。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>8、修订</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>卫付通平台可能根据法律法规的要求或业务运营的需求，不时会对本声明进行修订。对于涉及用户权益重大影响的隐私政策更新情形前，我们将选择在卫付通或卫付通关联公司网站或者移动设备客户端等以公告或声明更新的方式予以公布而不再另行单独通知您，该等修订将在公布时即时生效。若您在本政策修订后继续访问卫付通的网站及其相关网站、卫付通的移动设备客户端，或使用卫付通提供的任一服务，您确认这代表您已充分阅读、理解并接受修改后的本政策并受之约束，如果您不同意相关修订，您应该停止使用卫付通平台服务，并及时注销卫付通平台账号。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>9、效力和适用</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>您应认真阅读并充分理解本隐私政策所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿同意本政策。一旦您在线点击"同意"或勾选本隐私权保护声明即视为该等行为是您本人真实的意思表示，您同意承担由此带来的一切法律后果。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>10、联系我们</p>
        <div className={styles.emptyLine}></div>
        <p>我们已经配备个人信息保护专门负责人员，如您对本政策存在任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过以下渠道联系我们：</p>
        <p>（1）客服联系电话：4009600979</p>
        <p>（2）卫付通app的"在线客服"</p>
        <p>（3）邮寄地址： 上海市长宁区天山西路799号702</p>
        <p>（4）投诉电话：4009600979（工作日9:00-18:00）</p>
        <p>我们将在收到您的意见，在核实情况后，5个工作日之内向您反馈。如果您不满意我们的服务或答复，还可以向消费者权益保护部门投诉或向有管辖权的法院提起诉讼。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>11.法律管辖</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>因您与卫付通平台基于本政策的相关卫付通服务而产生的个人信息处理活动争议，您同意提交至上海市管辖。</p>
        <div className={styles.emptyLine}></div>
        <p>附件一 个人信息收集清单</p>
        <table border={1} cellSpacing={0} cellPadding={4}>
          <tbody>
            <tr>
              <td className={styles.bold}>序号</td>
              <td className={styles.bold}>处理个人信息目的</td>
              <td className={styles.bold}>处理个人信息方式</td>
              <td className={styles.bold}>处理个人信息种类</td>
            </tr>
            <tr>
              <td>1</td>
              <td>首次注册或重新注册账号时用以验证该电话号码的有效性</td>
              <td>收集、存储、使用</td>
              <td>电话号码、短信验证码</td>
            </tr>
            <tr>
              <td>2</td>
              <td>验证登录账号</td>
              <td>收集、存储、使用</td>
              <td>根据用户的选择，收集：短信验证码、登录手势、指纹（我们仅接收验证结果，并不收集您的指纹信息）、一键登录功能时，需要收集您的电话号码及设备信息、使用第三方平台账号进行快捷登录或通过第三方客户端或网站进行联合登录时，收集您的第三方平台账号及所对应的个人信息（包括openlD、电话号码、姓名、身份证信息、设备识别号、昵称、头像、性别、地区、用户状态，具体以第三方平台要求为准）。</td>
            </tr>
            <tr>
              <td>3</td>
              <td>核实用户真实身份</td>
              <td>收集、存储、向卫付通平台合作的指定第三方数据源传输用以验证查询</td>
              <td>姓名、有效证件信息及手机号码，人脸信息</td>
            </tr>
            <tr>
              <td>4</td>
              <td>提供担保服务</td>
              <td>收集、存储、使用</td>
              <td>包括但不限于：姓名、有效证件信息、手机号、婚姻情况、学历、居住城市、居住地址、行业、职业、公司名称、公司性质、职位、行驶证信息(包括影像)、交通违章信息、法院失信执行信息、不动产信息(包括影像)、动产信息、经营情况信息、保险信息、证券信息、纳税信息、收入信息、公积金及社保信息</td>
            </tr>
            <tr>
              <td>5</td>
              <td>提供融资咨询推荐服务</td>
              <td>收集、存储、向您同意并授权的第三方融资咨询服务机构传输您授权提供的信息</td>
              <td>包括但不限于：姓名、有效证件信息、手机号、婚姻情况、学历、居住城市、居住地址、行业、职业、公司名称、公司性质、职位、当前单位工龄、工资发放形式、月收入、年收入、邮箱、联系人信息、还款来源、社保缴纳、公积金缴纳、房产信息、车辆信息、保险保单信息、芝麻分、信用卡信息、银行卡信息</td>
            </tr>
            <tr>
              <td>6</td>
              <td>宣传营销推广：以电话或短信方式联系您，向你推荐合适的贷款产品</td>
              <td>使用</td>
              <td>姓名、手机号码</td>
            </tr>
            <tr>
              <td>7</td>
              <td>为识别和验证您的用户身份</td>
              <td>收集、存储、使用</td>
              <td>唯一设备识别码（如Android ID、IMEI、IMSI、Unique ID、MAC地址、IDFA/IDFV）以及本机号码</td>
            </tr>
            <tr>
              <td>8</td>
              <td>反欺诈识别及满足风险控制要求</td>
              <td>收集、存储、使用</td>
              <td>卫付通平台的相关网站、服务端、移动设备客户端时，或使用卫付通服务时的操作日志，包括您的计算机IP地址、已安装APP信息、设备序列号、ICCID、设备标识符（IMEI、Android ID、MAC、OAID等）、硬件型号、操作系统版本、浏览器的类型、使用的语言、访问日期和时间、网页记录、您的位置以及与卫付通服务相关的日志信息</td>
            </tr>
            <tr>
              <td>9</td>
              <td>创建数据分析模型，为您提供适合于您的服务，并维护、改进这些服务，可能用于预防、发现、调查存在欺诈、危害安全、非法或违反与卫付通声明、政策或规则的行为</td>
              <td>收集、存储、使用</td>
              <td>您在申请、使用卫付通平台相关服务时所提供及所形成的信息和数据</td>
            </tr>
            <tr>
              <td>10</td>
              <td>便于您查询自己的申请记录及订单状态等</td>
              <td>收集、存储</td>
              <td>您访问和接受服务的状态、交易信息和历史记录</td>
            </tr>
          </tbody>
        </table>
        <div className={styles.emptyLine}></div>
        <p>附件二 个人信息处理规则</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>第一章 一般规则</p>
        <div className={styles.emptyLine}></div>
        <p>第一条&nbsp;&nbsp;符合下列情形之一的，"卫付通"平台可以处理您的个人信息：</p>
        <p>（一）取得个人的同意；</p>
        <p>（二）为订立、履行个人作为一方当事人的合同所必需；</p>
        <p>（三）为履行法定职责或者法定义务所必需；</p>
        <p>（四）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
        <p>（五）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
        <p>（六）依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</p>
        <p>（七）法律、行政法规规定的其他情形。</p>
        <p>依照规则约定，处理个人信息应当取得个人同意，但是有前款第二项至第七项规定情形的，不需取得个人同意。</p>
        <p>第二条&nbsp;&nbsp;基于个人同意处理个人信息的，该同意应当由个人在充分知情的前提下自愿、明确作出。法律、行政法规规定处理个人信息应当取得个人单独同意或者书面同意的，从其规定。</p>
        <p>个人信息的处理目的、处理方式和处理的个人信息种类发生变更的，应当重新取得个人同意。</p>
        <p>第三条&nbsp;&nbsp;基于个人同意处理个人信息的，个人有权撤回其同意。</p>
        <p>个人撤回同意，不影响撤回前基于个人同意已进行的个人信息处理活动的效力。</p>
        <p>第四条&nbsp;&nbsp;"卫付通"平台不会以个人不同意处理其个人信息或者撤回同意为由，拒绝提供产品或者服务；处理个人信息属于提供产品或者服务所必需的除外。</p>
        <p>第五条&nbsp;&nbsp;"卫付通"平台在处理个人信息前，将以显著方式、清晰易懂的语言真实、准确、完整地向个人告知下列事项：</p>
        <p>（一）"卫付通"平台的名称或者姓名和联系方式；</p>
        <p>（二）个人信息的处理目的、处理方式，处理的个人信息种类、保存期限；</p>
        <p>（三）个人行使本法规定权利的方式和程序；</p>
        <p>（四）法律、行政法规规定应当告知的其他事项。</p>
        <p>前款规定事项发生变更的，"卫付通"平台应将变更部分告知个人。</p>
        <p>"卫付通"平台通过制定个人信息处理规则的方式告知第一款规定事项的，处理规则应当公开，并且便于查阅和保存。</p>
        <p>第六条&nbsp;&nbsp;"卫付通"平台处理个人信息，有法律、行政法规规定应当保密或者不需要告知的情形的，可以不向个人告知前条第一款规定的事项。</p>
        <p>紧急情况下为保护自然人的生命健康和财产安全无法及时向个人告知的，"卫付通"平台应当在紧急情况消除后及时告知。</p>
        <p>第七条&nbsp;&nbsp;除法律、行政法规另有规定外，"卫付通"平台对个人信息的保存期限为实现处理目的所必要的最短时间。</p>
        <p>第八条 "卫付通"平台与其他机构共同决定个人信息的处理目的和处理方式的，应当约定各自的权利和义务。</p>
        <p>"卫付通"平台与其他机构共同处理个人信息，侵害个人信息权益造成损害的，应当依法承担连带责任。</p>
        <p>第九条&nbsp;&nbsp;"卫付通"平台委托处理个人信息的，应当与受托人约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。</p>
        <p>受托人应当按照约定处理个人信息，不得超出约定的处理目的、处理方式等处理个人信息；委托合同不生效、无效、被撤销或者终止的，受托人应当将个人信息返还"卫付通"平台或者予以删除，不得保留。</p>
        <p>未经"卫付通"平台同意，受托人不得转委托他人处理个人信息。</p>
        <p>第十条&nbsp;&nbsp;"卫付通"平台因合并、分立、解散、被宣告破产等原因需要转移个人信息的，应当向个人告知接收方的名称或者姓名和联系方式。接收方应当继续履行"卫付通"平台的义务。接收方变更原先的处理目的、处理方式的，应当依照本法规定重新取得个人同意。</p>
        <p>第十一条&nbsp;&nbsp;"卫付通"平台向其他第三方机构提供其处理的个人信息的，应当向个人告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得个人的单独同意。接收方应当在上述处理目的、处理方式和个人信息的种类等范围内处理个人信息。接收方变更原先的处理目的、处理方式的，应当依照本法规定重新取得个人同意。</p>
        <p>第十二条&nbsp;&nbsp;"卫付通"平台利用个人信息进行自动化决策，应当保证决策的透明度和结果公平、公正，不得对个人在交易价格等交易条件上实行不合理的差别待遇。</p>
        <p>通过自动化决策方式向个人进行信息推送、商业营销，应当同时提供不针对其个人特征的选项，或者向个人提供便捷的拒绝方式。</p>
        <p>通过自动化决策方式作出对个人权益有重大影响的决定，个人有权要求"卫付通"平台予以说明，并有权拒绝"卫付通"平台仅通过自动化决策的方式作出决定。</p>
        <p>第十三&nbsp;&nbsp;条"卫付通"平台不得公开其处理的个人信息，取得个人单独同意的除外。</p>
        <p>第十四&nbsp;&nbsp;"卫付通"平台可以在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；个人明确拒绝的除外。"卫付通"平台处理已公开的个人信息，对个人权益有重大影响的，应当依照本法规定取得个人同意。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>第二章&nbsp;&nbsp;敏感个人信息的处理规则</p>
        <div className={styles.emptyLine}></div>
        <p>第十五条&nbsp;&nbsp;敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
        <p>只有在具有特定的目的和充分的必要性，并采取严格保护措施的情形下，"卫付通"平台方可处理敏感个人信息。</p>
        <p>第十六条&nbsp;&nbsp;处理敏感个人信息应当取得个人的单独同意；法律、行政法规规定处理敏感个人信息应当取得书面同意的，从其规定。</p>
        <p>第十七条&nbsp;&nbsp;"卫付通"平台处理敏感个人信息的，除本规则第一条第一款规定的事项外，还应当向个人告知处理敏感个人信息的必要性以及对个人权益的影响；依照法律法规可以不向个人告知的除外。</p>
        <p>第十八条&nbsp;&nbsp;"卫付通"平台处理不满十四周岁未成年人个人信息的，应当取得未成年人的父母或者其他监护人的同意。</p>
        <p>第十九条&nbsp;&nbsp;法律、行政法规对处理敏感个人信息规定应当取得相关行政许可或者作出其他限制的，从其规定。</p>
        <div className={styles.emptyLine}></div>
      </>
    )
  }

  return (
    <div className={classNames(styles.privacyAgreement, isShowHeader && styles.isShowHeader)}>
      {
        isShowHeader && <Header title="隐私协议" />
      }
      {
        youqianlaiPrivacy()
      }
    </div>
  )
}

export default PrivacyAgreement